import { StateCreator } from "zustand";
import { TStore } from "../store";

export type TNotificationStore = {
  readNotificationIds: Set<number>;

  // Actions
  markNotificationAsRead: (notificationId: number) => void;
  markMultipleNotificationsAsRead: (notificationIds: number[]) => void;
  isNotificationRead: (notificationId: number) => boolean;
  setReadNotifications: (ids: Set<number>) => void;
  clearReadNotifications: () => void;
};

const initialNotificationState = {
  readNotificationIds: new Set<number>(),
};

export const createNotificationSlice: StateCreator<
  TStore,
  [],
  [],
  TNotificationStore
> = (set, get) => ({
  ...initialNotificationState,

  markNotificationAsRead: (notificationId: number) => {
    set((state) => ({
      readNotificationIds: new Set([
        ...state.readNotificationIds,
        notificationId,
      ]),
    }));
  },

  markMultipleNotificationsAsRead: (notificationIds: number[]) => {
    set((state) => ({
      readNotificationIds: new Set([
        ...state.readNotificationIds,
        ...notificationIds,
      ]),
    }));
  },

  isNotificationRead: (notificationId: number) => {
    return get().readNotificationIds?.has(notificationId) ?? false;
  },

  setReadNotifications: (ids: Set<number>) => {
    set({ readNotificationIds: ids });
  },

  clearReadNotifications: () => {
    set({ readNotificationIds: new Set<number>() });
  },
});
